import SearchController from './search-controller'

export default SearchController
